import type { PlaybookVersion } from '@onefootprint/request-types/dashboard';
import usePermissions from '@/hooks/use-permissions';

const useCanEdit = () => {
  const { hasPermission } = usePermissions();

  return (playbookVersion?: PlaybookVersion) => {
    const hasOnboardingConfigPermission = hasPermission('onboarding_configuration');
    const isImmutable = playbookVersion?.isImmutable;
    const isBankLinking = playbookVersion?.kind === 'bank_linking';

    return hasOnboardingConfigPermission && !isImmutable && !isBankLinking;
  };
};

export default useCanEdit;
